import { OrderSelection } from '~/types/Order';
import Rate from '~/types/Rate';
import Shipment from '~/types/Shipment';
import { ActionKeys } from './constants';
import { TrackingReference } from '~/utils/TrackingHelper/types';

export interface FetchShipmentRatesPayload {
  rates: Rate[];
}

export interface FetchShipmentPayload {
  shipment: Shipment;
}

export function fetchShipment(shipmentId: string, trackingReference: TrackingReference) {
  return <const>{
    shipmentId,
    trackingReference,
    type: ActionKeys.SHIPMENT_FETCH,
  };
}

export function fetchShipmentRatesSuccess(
  shipmentId: string,
  payload: FetchShipmentPayload,
  trackingReference: TrackingReference,
) {
  return <const>{
    payload,
    shipmentId,
    trackingReference,
    type: ActionKeys.SHIPMENT_FETCH_SUCCESS,
  };
}

export function fetchShipmentRatesError(shipmentObjectId: string) {
  return <const>{
    type: ActionKeys.SHIPMENT_FETCH_ERROR,
    payload: {
      shipmentObjectId,
    },
  };
}

export function retryAutoSelectRates() {
  return <const>{
    type: ActionKeys.RETRY_AUTO_SELECT_RATES,
  };
}

export function selectRate(
  shipmentObjectId: string,
  rateObjectId: string,
  userTriggered = true,
  trackingReference: TrackingReference,
  orderSelection?: OrderSelection,
  serviceLevelToken?: string,
  accountObjectId?: string,
) {
  return <const>{
    type: ActionKeys.RATE_SELECT,
    payload: {
      orderSelection,
      rateObjectId,
      serviceLevelToken,
      shipmentObjectId,
      userTriggered,
      accountObjectId,
      trackingReference,
    },
  };
}

export function selectRates(
  orderSelection: OrderSelection,
  rateSelection: HashMap<string, string>,
  serviceLevelToken: string,
  serviceLevelKey: string,
  shouldIgnoreCarrier: boolean,
  trackingReference: TrackingReference,
  accountObjectId?: string,
) {
  return <const>{
    type: ActionKeys.MULTIPLE_RATE_SELECT,
    payload: {
      orderSelection,
      rateSelection,
      serviceLevelToken,
      serviceLevelKey,
      shouldIgnoreCarrier,
      accountObjectId,
      trackingReference,
    },
  };
}

export function clearRates(shipmentIds: string[]) {
  return <const>{
    type: ActionKeys.RATE_CLEAR,
    payload: {
      shipmentIds,
    },
  };
}

export type ShipmentsActions =
  | ReturnType<typeof fetchShipment>
  | ReturnType<typeof fetchShipmentRatesSuccess>
  | ReturnType<typeof fetchShipmentRatesError>
  | ReturnType<typeof retryAutoSelectRates>
  | ReturnType<typeof selectRate>
  | ReturnType<typeof selectRates>
  | ReturnType<typeof clearRates>;
